<template>
    <div v-clickaway="collapse" class="sidebar">
        <div class="sidebar-inner">
            <div class="sidebar-logo">
                <router-link :to="{ name: 'home' }" class="sidebar-link td-n">
                    <div class="logo">
                        <img src="@/assets/logo.png" alt="">
                    </div>
                </router-link>
            </div>

            <ul class="sidebar-menu">
                <li class="nav-item" @click="collapse">
                    <router-link :to="{ name: 'admin' }" class="sidebar-link">
                        <span class="icon-holder">
                            <i class="tlm-icon-chart" />
                        </span>
                        <span class="title">Компании</span>
                    </router-link>
                </li>

                <li class="nav-item" @click="collapse">
                    <router-link :to="{ name: 'admin.modems' }" class="sidebar-link">
                        <span class="icon-holder">
                            <i class="tlm-icon-modem" />
                        </span>
                        <span class="title">Модемы</span>
                    </router-link>
                </li>

                <li class="nav-item" @click="collapse">
                    <router-link :to="{ name: 'admin.transactions' }" class="sidebar-link">
                        <span class="icon-holder">
                            <i class="tlm-icon-info-circle" />
                        </span>
                        <span class="title">Корректировки</span>
                    </router-link>
                </li>

                <li class="nav-item" @click="collapse">
                    <router-link :to="{ name: 'admin.billing' }" class="sidebar-link">
                        <span class="icon-holder">
                            <i class="tlm-icon-excel" />
                        </span>
                        <span class="title">Биллинг</span>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        isMobile: {
            get() {
                return this.$store.state.isMobile
            },
            set(value) {
                this.$store.commit('isMobile', value)
            }
        }
    },

    methods: {
        collapse() {
            if (this.isMobile) {
                this.$emit('collapse')
            }
        }
    }
}
</script>
